/**
 * @description
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { CommentParentType } from '@umu/umu-types';

export interface IInput {
    parent_type: CommentParentType;
    comment_ids: string;
}

export interface IOutput {
    count: number;
}

export const commentDelete = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.COMMENT_DELETE, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
};
